import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";

// Vanta types
declare global {
  interface Window {
    VANTA: {
      CLOUDS: (config: Record<string, unknown>) => { destroy: () => void };
    };
  }
}

const VantaBackground: React.FC = () => {
  const vantaRef = useRef<HTMLDivElement>(null);
  const [vantaEffect, setVantaEffect] = useState<{ destroy: () => void } | null>(null);

  useEffect(() => {
    // Dynamically load Vanta.js
    const loadVanta = async () => {
      if (!vantaRef.current) return;
      
      // Make THREE available globally for Vanta
      (window as unknown as { THREE: typeof THREE }).THREE = THREE;

      // Load Vanta clouds script
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/vanta@0.5.24/dist/vanta.clouds.min.js";
      script.async = true;
      
      script.onload = () => {
        if (window.VANTA && vantaRef.current) {
          const effect = window.VANTA.CLOUDS({
            el: vantaRef.current,
            THREE: THREE,
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.0,
            minWidth: 200.0,
            skyColor: 0x825492,
            cloudColor: 0xddcbed,
            sunColor: 0xed7ed7,
            sunGlareColor: 0xb93aca,
            sunlightColor: 0xe38fe3,
            speed: 0.8,
          });
          setVantaEffect(effect);
        }
      };

      document.head.appendChild(script);
    };

    loadVanta();

    return () => {
      if (vantaEffect) {
        vantaEffect.destroy();
      }
    };
  }, []);

  return (
    <div
      ref={vantaRef}
      className="fixed inset-0 w-full h-screen z-0"
      style={{ top: 0, left: 0 }}
    />
  );
};

export default VantaBackground;
